import type { FeedFormula } from './feed';

export const enum PromptCardRedesign {
    Old = 'old',
    New = 'new',
}

export type Flags = {
    /**
     * Тестовый эксперимент для отладки подключения Varioqub
     */
    test: 'value_a' | 'value_b' | 'value_c';

    /**
     * Флаг переключения формулы для экспериментов с ранжированием
     */
    rankingFormula: FeedFormula;

    /**
     * Параметры формулы для ранжирования в формате json, закодированные в base64
     */
    formulaParams: string;

    /**
     * Эксперимент с редизайном карточки промпта  https://st.yandex-team.ru/LPC-21909 и https://st.yandex-team.ru/PROMPTHUB-33
     */
    promptCardRedesign: PromptCardRedesign;
};
